module.exports = __webpack_public_path__ + "img/datawall1.0de65bf2.jpg";